module.exports = __webpack_public_path__ + "media/32/e-remove-e270927c.svg";